// import Vue from 'vue'
// import VueMask from 'v-mask'

// Vue.use(VueMask);

//import { VueMaskDirective } from 'v-mask'
//Vue.directive('mask', VueMaskDirective);

import Vue from 'vue'
import VueTheMask from 'vue-the-mask'
Vue.use(VueTheMask)

